import { render } from "./DashboardRepoList.vue?vue&type=template&id=e0733416&scoped=true&ts=true"
import script from "./DashboardRepoList.vue?vue&type=script&lang=ts"
export * from "./DashboardRepoList.vue?vue&type=script&lang=ts"

import "./DashboardRepoList.vue?vue&type=style&index=0&id=e0733416&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0733416"]])

export default __exports__